import React from 'react';
import Homepage from '../components/Homepage'
import {Route, Routes } from "react-router";
import Layout from "./Layout";
import TwentyTwentyFour from "../components/TwentyTwentyFour";
import TwentyTwentyFive from "../components/TwentyTwentyFive";
import Login from '../components/Login';
import Register from '../components/Register';
import Chat from '../components/Chat';


function App() {

  return (
      <>
          <Routes>
              <Route element={<Layout />}>
                <Route path="/ff" element={<Homepage />} />
                <Route path="/ff/2024" element={<TwentyTwentyFour />} />
                <Route path="/ff/2025" element={<TwentyTwentyFive />} />
                <Route path="/ff/login" element={<Login />} />
                <Route path="/ff/register" element={<Register />} />
              </Route>
          </Routes>
          <Chat />
      </>
  );
}

export default App;
